import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { TlsProfile } from 'data/tlsProfile/tlsProfile.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: TlsProfile,
  originalDigitExtractionServerFormData: TlsProfile | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SECURITY_INFO_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SECURITY_INFO_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.name,
    AuditService.SECURITY_INFO,
    actionType,
  );
  return auditDetails as AuditDetails;
}
